module.exports = __webpack_public_path__ + "img/3.b77075b5.webp";